{
  "id": "town-center",
  "role": "town-center",
  "width": 3,
  "height": 3,
  "dropOff": ["gold", "lumber"],
  "supplyProvided": 5,
  "trains": ["worker"],
  "cost": {
    "gold": 300,
    "lumber": 150
  },
  "buildTicks": 600,
  "hp": 1200
}
